export const getReferralEncryption = (code: string): string =>
  code
    .split('')
    .map((item: string) => item.charCodeAt(0))
    .join('');

interface ReferredEmployee {
  tnxPoint: number | null;
  loginPoint: number | null;
}

interface ReferralData {
  employeesReferred: ReferredEmployee[];
}

export const calculateTotalPoints = (data: ReferralData): number => {
  let totalPoints = 0;

  data.employeesReferred.forEach(employee => {
    if (employee.tnxPoint !== null) {
      totalPoints += employee.tnxPoint;
    }

    if (employee.loginPoint !== null) {
      totalPoints += employee.loginPoint;
    }
  });

  return totalPoints;
};
